import script from "./FormFieldOption.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldOption.vue?vue&type=script&setup=true&lang=js"

import "./FormFieldOption.vue?vue&type=style&index=0&id=8ddcb726&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ddcb726"]])

export default __exports__